<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-blue-400 hover:text-blue-600" href="/regions">Regions</Link>
      <span class="text-blue-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="region.deleted_at" class="mb-6" @restore="restore"> This region has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="! region.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Region</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Update Region</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,

    TrashedMessage,
  },
  layout: Layout,
  props: {
    region: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name         : this.region.name,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/regions/${this.region.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this region?')) {
        this.$inertia.delete(`/regions/${this.region.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this region?')) {
        this.$inertia.put(`/regions/${this.region.id}/restore`)
      }
    },
  },
}
</script>
